import { render, staticRenderFns } from "./ProductSettingWidget.vue?vue&type=template&id=55035a82&scoped=true&"
import script from "./ProductSettingWidget.vue?vue&type=script&lang=js&"
export * from "./ProductSettingWidget.vue?vue&type=script&lang=js&"
import style0 from "./ProductSettingWidget.vue?vue&type=style&index=0&id=55035a82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55035a82",
  null
  
)

export default component.exports